/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportDetectionMethodDtoTestResult =
  (typeof LabReportDetectionMethodDtoTestResult)[keyof typeof LabReportDetectionMethodDtoTestResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportDetectionMethodDtoTestResult = {
  PENDING: 'PENDING',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NOT_EXECUTED: 'NOT_EXECUTED',
} as const;
